import type { LeadAddressFormFields } from './lead-address-form.interface';

export const LeadAddressFormDefaults: {
  fields: { [Key in keyof LeadAddressFormFields]: string };
} = {
  fields: {
    PostalCodeLabel: 'Postcode',
    PostalCodeRequiredError: 'Postcode is verplicht',
    PostalCodeInvalidError: 'Postcode is ongeldig',

    HouseNumberLabel: 'Huisnummer',
    HouseNumberRequiredError: 'Huisnummer is verplicht',

    HouseNumberAdditionLabel: 'Toevoeging',

    StreetLabel: 'Straat',
    StreetRequiredError: 'Straat is verplicht',

    CityLabel: 'Plaats',
    CityRequiredError: 'Plaats is verplicht',
  },
};
